import * as React from 'react';
import { ContextStore } from 'bernie-core';
import { UitkButtonSize } from 'uitk-react-button';
import { AnalyticsType, HttpURI } from 'types/shared';
import { FlightsActionType, FlightsStandardOffer } from '__generated__/api';
import { PrimaryButtonTracked } from 'components/shared/tracked';
import { trackAnalytics } from 'utility';
import { useStores } from 'utility/hooks';
import analyticsWrapper from 'utility/analytics-wrapper';

export interface SelectActionProps {
  displayAction: string;
  url?: HttpURI;
  isDisabled: boolean;
  onOfferSelect: (e: Event) => void;
  analytics: AnalyticsType;
  analyticsList?: AnalyticsType[];
  context?: ContextStore;
  offerFareSelection?: boolean;
  flightsActionType?: FlightsActionType;
  openUrlInNewTab?: boolean;
  index?: number;
  accessibilityMessage?: string;
  onApplySelect?: (e: string) => void;
  identifier?: string;
  journeySearchCriteria?: FlightsStandardOffer.JourneySearchCriteria;
  journeyContinuationId?: string;
}
export const SelectAction = ({
  displayAction,
  url,
  isDisabled,
  onOfferSelect,
  flightsActionType,
  index,
  accessibilityMessage,
  onApplySelect,
  identifier,
  journeySearchCriteria,
  journeyContinuationId
}: SelectActionProps) => {
  const {
    context,
    routeStore,
    dialogsStore,
    analytics: analyticsStore,
    searchCriteriaStore,
    stepIndicatorStore
  } = useStores();
  const { setJourneyContinuationIdInStepIndicator } = stepIndicatorStore;

  const offerSelectHandle = () => {
    if (flightsActionType === FlightsActionType.GO_TO_NEXT_JOURNEY && url) {
      const nextUrl = new URL(url.value);

      searchCriteriaStore.setJourneysContinuationId(nextUrl && nextUrl.searchParams.get('journeysContinuationId'));
      searchCriteriaStore.pageId = (nextUrl && nextUrl.searchParams.get('pageId')) || '0';

      if (journeySearchCriteria && journeySearchCriteria.previousFlightSelections) {
        searchCriteriaStore.syncPreviousFlightSelections(journeySearchCriteria.previousFlightSelections);
      }
      searchCriteriaStore.fetchFlexResults = false;
      searchCriteriaStore.cleanUpSortFilterOption();
      searchCriteriaStore.triggerSearch(routeStore, context, true, false, false);

      setJourneyContinuationIdInStepIndicator(journeyContinuationId);
      analyticsWrapper.resetSearchResultsAnalyticsPayLoad(analyticsStore);
    } else if (flightsActionType === FlightsActionType.DISMISS) {
      onApplySelect(identifier);
    } else if (
      flightsActionType === FlightsActionType.LOAD_CROSS_SELL_DIALOG ||
      flightsActionType === FlightsActionType.GO_TO_DETAILS
    ) {
      if (
        dialogsStore.getForcedChoiceModalDialog() &&
        dialogsStore.forcedChoiceDisplayedCounter >= dialogsStore.getForcedChoiceModalDialog().displayCounter
      ) {
        trackAnalytics(dialogsStore.getForcedChoiceModalDialog().displayBlockedAnalytics, analyticsStore);
      }
      onOfferSelect.call(null);
    }
  };

  const sharedProps = {
    'data-test-id': index ? `select-button-${index++}` : 'select-button'
  };

  if (context.deviceInformation.mobile) {
    Object.assign(sharedProps, { role: 'link' });
  }

  return (
    <PrimaryButtonTracked
      {...sharedProps}
      disabled={isDisabled}
      text={displayAction}
      className="all-l-margin-three"
      aria-label={accessibilityMessage}
      size={UitkButtonSize.LARGE}
      onClick={offerSelectHandle}
    />
  );
};
